import React from 'react';

import { Paper, TableCell, TableContainer } from '@material-ui/core';

import { theme } from 'styles';

import styled from 'styled-components/macro';

export const Table = styled.div`
  width: 100%;
  border-radius: 8px;
  display: flex;
  flex-direction: column;

  @media (max-width: 470px) {
    .MuiToolbar-gutters {
      padding-left: 6px;
    }

    .MuiTablePagination-selectRoot {
      margin-right: 10px;
    }

    .MuiTablePagination-actions {
      margin-left: 0px;
    }

    .MuiIconButton-root {
      padding: 4px;
    }
  }
`;

export const TableBody = styled.div<{ columnsCount: number; cellCount: number; topComponent: boolean }>`
  display: grid !important;
  align-items: center;
  grid-template-columns: repeat(${p => p.columnsCount}, 1fr);
  align-items: stretch;

  & > :nth-child(${p => p.cellCount - p.columnsCount + 1}) {
    border-bottom-left-radius: 8px;
  }

  & > :nth-child(${p => p.cellCount}) {
    border-bottom-right-radius: 8px;
  }

  border-radius: 8px;

  .header-cell {
    min-height: 58px;
    min-width: 181px;
    font-family: Proxima Nova;
    font-weight: 700;
    color: ${theme.palette.primary.main};
    overflow-wrap: normal;

    &:first-child {
      background: #fff;
      border-top-left-radius: ${props => (props.topComponent ? '0px' : '8px')};
    }

    &:last-of-type {
      border-top-right-radius: ${props => (props.topComponent ? '0px' : '8px')};
    }
  }
`;

type CellProps = {
  bold?: boolean;
  underline?: boolean;
  topComponent?: boolean;
  width?: number;
} & React.ComponentProps<'div'>;

function handleWidth(props: CellProps) {
  let defaultWidth = '100% !important';

  if (props?.style?.width) {
    defaultWidth = `${props?.style?.width}px !important`;
  }
  if (props?.width) {
    defaultWidth = `${props?.width}px !important`;
  }

  return defaultWidth;
}

export const CustomTableCellCN = styled(TableCell)<CellProps>`
  width: ${handleWidth};
  min-width: 100% !important;
  min-height: 100%;
  /* border: ${props => (props.topComponent ? '1px solid lightgray' : '1px solid #30303030')}; */
  /* text-decoration: ${props => props.underline && 'underline'}; */
  font-weight: ${props => props.bold && 'bold'};
  text-decoration: none;
  color: ${theme.palette.text.primary};
  min-height: 0;

  & a:link,
  & a:visited,
  & a:hover,
  & a:active {
    color: rgba(0, 0, 0, 0.87);
    overflow: 'hidden';
    text-overflow: 'ellipsis';
  }
`;

export const Container = styled(TableContainer)`
  border-radius: 1.5rem 1.5rem 0 0;
  .MuiTableCell-sizeSmall {
    padding: 8px 24px;
  }
`;

export const FlexContainer = styled.div`
  display: flex;
  flex: 1;
  min-height: 0px;
`;

export const OverflowContainer = styled.div`
  flex: 1;
  overflow: auto;
  border-radius: 8px;
  box-shadow: 0px 3px 6px #0000000f;
`;

export const RelativeContainer = styled(Paper)<{ minHeight?: number }>`
  min-height: ${p => p.minHeight}px;
  width: 100%;
  margin-bottom: ${theme.spacing(2)}px;
  border-radius: 1.5rem;
`;

export default Container;
